import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';

import useClientSide from 'hooks/useClientSide';
import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import StoreItem from './StoreItem';

const PopularCouponsStores = ({ gaEventCategory, stores }) => {
  const isClientSide = useClientSide();
  const { isMd } = useMediaQuery();
  const [isExpandedEnabled, setIsExpandedEnabled] = useState(false);

  const popularCouponStores = useMemo(
    () =>
      isClientSide && !isMd && !isExpandedEnabled ? stores.slice(0, 6) : stores,
    [isMd, isExpandedEnabled, isClientSide]
  );

  const onExpandStoresStores = () => {
    setIsExpandedEnabled(true);
    sendEvent({ action: 'see_more_popular_stores', category: gaEventCategory });
  };

  return (
    <section className="flex flex-col gap-8">
      <Heading as="h1" size="size4">
        {placeholder('seo.storeCoupons.title')}
      </Heading>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:grid-cols-6">
        {popularCouponStores.map((store) => (
          <StoreItem
            key={store.storeSlug}
            gaEventCategory={gaEventCategory}
            {...store}
          />
        ))}
        {!isExpandedEnabled && (
          <Button
            className="col-span-full w-full md:hidden"
            size="size3"
            full
            onClick={onExpandStoresStores}
          >
            {placeholder('actions.seeMore')}
          </Button>
        )}
      </div>
    </section>
  );
};

PopularCouponsStores.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeName: PropTypes.string,
      storeImage: PropTypes.string,
      storeSlug: PropTypes.string,
      totalCoupons: PropTypes.number,
    })
  ).isRequired,
};

export default PopularCouponsStores;
